import {Grid} from 'jrgrid';
import { columns } from './utils';
import { pageVerificationView } from './api';
import Navbar from '../../../components/Navbar';
import React, { Fragment } from 'react';

export const DeletedItems = () => {
  return (
    <Fragment>
      <Navbar />
      <h2 className="ml-5 mt-2">Deleted Items</h2>
      <div className="ml-5 mr-5">
        <Grid
          amount={20}
          columns={columns}
          defaultSortField="VerifyId"
          query={pageVerificationView}
          queryName="pageVerificationView"
          globalFilters={[
            {
              id: 'isDeleted',
              isLike: false,
              operand: 'and',
              type: 'string',
              value: '1',
            },
          ]}
        />
      </div>
    </Fragment>
  );
};
